export let datatypes = {
    users: {
        endpoint: '/api/auth/users/',
        fields: [
            {name: "name", placeholder: "User Name", label: "Name", required: true},
            {name: "title", placeholder: "Title", label: "Title"},
            {name: "email", placeholder: "Email", label: "Email", type: "email", required: true},
            {name: "phone", placeholder: "Phone", label: "Phone", type:"tel"},
            {name: "pwd", placeholder: "Password", label: "Password", type: "password"}
        ]
    },
    assessment: {
        endpoint: '/api/assessments/',
        fields: [
            {name: 'company_full_name', placeholder:"Acme Limited LLC", label: "Full Company Name", required: true},
            {name: 'company_short_name', placeholder:"Acme", label: "Short Company Name"},
            {name: 'counsel', placeholder:"Duey, Cheatham & Howe LLP", label: "Client Counsel"},
            {name: 'matter_number', placeholder:"123456", label: "Matter Number"},
            {name: 'start_date', placeholder:"Start Date", label: "Start Date", type:"date"},
            {name: 'end_date', placeholder:"End Date", label: "End Date", type:"date"},
            {name: 'assessment_type_id', type:'select', label: "Assessment Type", choices: {
                model: "assessmentType",
                label: "name",
                value: "id"
            }}
        ]
    },
    assessmentFinding: {
        endpoint: '/api/assessments/findings/'
    },
    assessmentHosts: {
        endpoint: '/api/assessments/finding_hosts/'
    },
    assessmentType: {
        endpoint: '/api/assessments/types/',
        fields: [
            {name: 'name', placeholder: "Name", label: "Name"},
            // {name: 'templateFile', label: "Template File", type: "select", choices: {
            //         static: [
            //             {label: 'Pentest Report', value: 'pentest_report.docx'},
            //             {label: 'Webapp Report', value: 'webapp_report.docx'}
            //         ]
            //     }
            // }
        ]
    },
    snippet: {
        endpoint: '/api/snippets/',
        fields: [
            {name: 'name', placeholder: "Sample Snippet", label: "Name"},
        ]
    },
    transform: {
        endpoint: '/api/transforms/',
        fields: [
            {name: "name"},
            {name: "combine", default: false},
            {name: "extractions", default: []},
            {name: "transforms", default: []}
        ]
    },
    table: {
        endpoint: '/api/findings/tables/',
        fields: [
            {name: "name"},
            {name: "data", default: {
                rows: 3,
                cols: 4,
                row_styles: {},
                col_styles: {},
                cell_styles: {},
                conditional_formatting: {},
                values: {},
                merge: []
            }}
        ]
    },
    nessus_scans: {
        endpoint: '/api/nessus/scans/'
    }
}